import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';

export const SidebarToggle = ({
  collapsed,
  toggleSidebar,
}: {
  collapsed: boolean;
  toggleSidebar: () => void;
}) => {
  return (
    <Button
      onClick={toggleSidebar}
      size={'icon-sm'}
      className={`absolute top-18 !w-5 h-5 z-100 rounded-full p-2 bg-ring/90 border -right-2.5 transition-all`}
    >
      <ChevronRight
        className={`w-4 h-4 text-background ${!collapsed ? 'rotate-180' : ''}`}
      />
    </Button>
  );
};
